import {client} from '@/services';
import Vue from 'vue';
import config from '@/config';
import { getSelectedVenue } from '@/services/helpers';

const groupsService = client.service('groups');
const groups = {
	namespaced: true,
	state: {
		groups: []
	},
	getters: {
		GET_GROUPS: (state) => {
			const groups = state.groups.sort((a, b) => a.name.localeCompare(b.name));
			return groups || [];
		}
	},
	mutations: {
		SET_GROUPS (state, groups) {
			state.groups = groups;
		},
		ADD_MORE_GROUPS (state, groups) {
			state.groups = Array.from(new Set(state.groups.concat(groups)));
		},
		ADD_GROUP (state, group) {
			state.groups.push(group);
		},
		UPDATE_GROUP (state, group) {
			const i = state.groups.findIndex((g) => g._id === group._id);

			// reactivity hack
			Vue.set(state.groups, i, group);
		},
		REMOVE_GROUP (state, _id) {
			const i = state.groups.findIndex((g) => g._id === _id);
			state.groups.splice(i, 1)
		}
	},
	actions: {
		async GET_GROUPS ({ rootState, commit }) {
			const query = {
				$paginate: {
					value: false
				}
			}

			if (!rootState.users.user.isAdmin) {
				query.venueId = getSelectedVenue()._id;
			}

			const groups = await groupsService.find({
				query
			});

			groups.forEach((group) => {
                if (group.thumbnail) {
                    group.serverPath = `${config.server_url}/uploads/thumbs/${group.thumbnail}`;
                }
            });

			commit('SET_GROUPS', groups);

			return groups;
		},
		async GET_CHANNELS_FROM_GROUPS ({}, ids) {
			const response = await groupsService.find({
				query: {
					$paginate: {
						value: false
					},
					_id: {
						$in: ids
					},
					$select: ['channels']
				}
			});

			let channels = [];
			response.forEach((g) => {
				if (typeof g.channels !== 'string') {
					g.channels = '';
				}
				const c = g.channels.split(',').map(c => c.replace(/\s/g,''));
				channels = [...channels, ...c];
			});
			return [...new Set(channels)];
		},
		async GET_GROUP_DATA ({}, groupId) {
			try {
				const response = await groupsService.find({
					query: {
						$limit: 1,
						_id: groupId
					}
				})
				return response.data
			} catch (e) {
				throw e
			}
		},
		async GET_DASHBOARD_GROUPS({ commit, dispatch }) {
			const groups = await groupsService.find({
				query: {
					showInDashboard: true,
					$paginate: {
						value: false
					}
				}
			});

			groups.forEach((group) => {
                if (group.thumbnail) {
                    group.serverPath = `${config.server_url}/uploads/thumbs/${group.thumbnail}`;
                }
            });

			commit('SET_GROUPS', groups);

			return groups;
		},
		async ADD_GROUP({ commit, dispatch }, group) {
			const groupNameExists = await dispatch('GROUP_NAME_EXISTS', {
				groupName: group.name,
				venueId: group.venueId
			});

			if (groupNameExists) {
				throw {
					code: 'name-exists',
					message: 'Group name already exists'
				}
			}

			const clone = JSON.parse(JSON.stringify(group));
			clone.created_at = Date.now();
			clone.venueId = getSelectedVenue()._id;

			const response = await groupsService.create(clone);

			commit('ADD_GROUP', response);

			return response;
		},
		async GROUP_NAME_EXISTS ({}, { groupName, venueId }) {
			const response = await groupsService.find({
				query: {
					name: groupName,
					venueId
				}
			})

			if (response.data.length > 0) {
				return true;
			}

			return false;
		},
		async UPDATE_GROUP({commit}, payload) {
			const clone = JSON.parse(JSON.stringify(payload.group));
			clone.updated_at = Date.now();

			const response = await groupsService.patch(payload._id, clone)

			commit('UPDATE_GROUP', response)

			return response
		},
		async DELETE_GROUP({commit, dispatch}, _id) {
			const response = await dispatch('schedules/SEARCH_DEVICE_GROUP', _id, {root: true});
			if (response.length === 0) {
				await groupsService.remove(_id);
				commit('REMOVE_GROUP', _id);
			}
			return response;
		}
	}
}

export default groups



// WEBPACK FOOTER //
// ./src/store/modules/groups.js